var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 6.929c0 0 0 3.2 0 3.2s32 0 32 0c0 0 0-3.2 0-3.2s-32 0-32 0M0 14.396c0 0 0 3.2 0 3.2s32 0 32 0c0 0 0-3.2 0-3.2s-32 0-32 0M0 21.863c0 0 0 3.2 0 3.2s32 0 32 0c0 0 0-3.2 0-3.2s-32 0-32 0"}));
}

IconMenu.defaultProps = {"version":"1.1","width":"32","height":"32","className":"icon","viewBox":"0 0 32 32"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
